import React from "react";
// import style from "./bar.module.css";

type BarDisplayProps = {
  x: number;
  y: number;
  type: string;
  startProgressWidth: number;
  endProgressWidth: number;
  width: number;
  height: number;
  isSelected: boolean;
  /* progress start point */
  progressX: number;
  progressWidth: number;
  barCornerRadius: number;
  criticalPathArrows?: Array<{taskId: string, arrowColor: string}>
  segments?: Array<{ x1: number; x2: number }>;
  styles: {
    taskProgressColor?: string;
    backgroundColor: string;
    backgroundSelectedColor: string;
    progressColor: string;
    progressSelectedColor: string;
    criticalPathColor?: string;
  };
  onMouseDown: (event: React.MouseEvent<SVGPolygonElement, MouseEvent>) => void;
};
export const BarDisplay: React.FC<BarDisplayProps> = ({
  x,
  y,
  type,
  width,
  height,
  isSelected,
  progressX,
  progressWidth,
  barCornerRadius,
  styles,
  segments,
  onMouseDown,
}) => {
  const getProcessColor = () => {
    return isSelected ? styles.progressSelectedColor : styles.progressColor;
  };

  const getBarColor = () => {
    return isSelected ? styles.backgroundSelectedColor : styles.backgroundColor;
  };

  if (type === "planned") {
    if (segments && segments.length > 0) {
      // Multi-segment rendering: one rect per working interval
      const totalWidth = width;
      return (
        <g onMouseDown={onMouseDown}>
          {segments.map((seg, idx) => (
            <rect
              key={`seg-${idx}`}
              x={seg.x1}
              width={seg.x2 - seg.x1}
              y={y}
              height={height}
              ry={barCornerRadius}
              rx={barCornerRadius}
              fill={getBarColor()}
              strokeWidth={2}
              stroke={styles.criticalPathColor}
            />
          ))}
          {/* Progress overlay: distribute progressWidth proportionally */}
          {progressWidth > 0 && (() => {
            const rects: React.ReactNode[] = [];
            let remaining = progressWidth;
            for (const seg of segments) {
              if (remaining <= 0) break;
              const segW = seg.x2 - seg.x1;
              const ratio = totalWidth > 0 ? segW / totalWidth : 0;
              const pw = Math.min(remaining, progressWidth * ratio);
              if (pw > 0) {
                rects.push(
                  <rect
                    key={`prog-${seg.x1}`}
                    x={seg.x1}
                    width={pw}
                    y={y}
                    height={height}
                    ry={barCornerRadius}
                    rx={barCornerRadius}
                    fill={getProcessColor()}
                  />
                );
                remaining -= pw;
              }
            }
            return rects;
          })()}
        </g>
      );
    }
    return (
      <g onMouseDown={onMouseDown}>
        <rect
          x={x}
          width={width}
          y={y}
          height={height}
          ry={barCornerRadius}
          rx={barCornerRadius}
          fill={getBarColor()}
          strokeWidth={2}
          stroke={styles.criticalPathColor}
        />
        <rect
          x={progressX}
          width={progressWidth}
          y={y}
          height={height}
          ry={barCornerRadius}
          rx={barCornerRadius}
          fill={getProcessColor()}
        />
      </g>
    );
  } else {
    if (segments && segments.length > 0) {
      return (
        <g onMouseDown={onMouseDown}>
          {segments.map((seg, idx) => (
            <rect
              key={`aseg-${idx}`}
              x={seg.x1}
              width={seg.x2 - seg.x1}
              y={y}
              height={height}
              ry={barCornerRadius}
              rx={barCornerRadius}
              fill={styles.taskProgressColor}
            />
          ))}
          <rect
            x={progressX}
            width={progressWidth}
            y={y}
            height={height}
            ry={barCornerRadius}
            rx={barCornerRadius}
            fill={getProcessColor()}
          />
        </g>
      );
    }
    return (
      <g onMouseDown={onMouseDown}>
        <rect
          x={x}
          width={width}
          y={y}
          height={height}
          ry={barCornerRadius}
          rx={barCornerRadius}
          fill={styles.taskProgressColor}
        />
        <rect
          x={progressX}
          width={progressWidth}
          y={y}
          height={height}
          ry={barCornerRadius}
          rx={barCornerRadius}
          fill={getProcessColor()}
        />
      </g>
    );
  }
};
